import {
  Box,
  Button,
  Flex,
  Icon,
  Input,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FaArrowLeft, FaArrowRight, FaPlay } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import {
  BLUEMONEDD,
  BLUEMONEDDBUTTONS,
  WHITE,
} from "../../../constants/colors";
import {
  ExtractListCards,
  simplifiedExtract,
} from "../../../interfaces/defaultInterfaces";
import { JWTToken } from "../../../routes/privateRoute";
import ExtratoApi from "../../../services/ExtratoAPI";
import ListReleases from "./components/listReleases";
import moment from "moment";
import jwt_decode from "jwt-decode";
import { dateForValueInput } from "../../../constants/dataFormat";
import DateDropdownFuture from "../../../defaultComponents/dateDropdownFuture";
import TableSalesCredit from "../consultaTransacoes/defaultComponents/tableSalesCredit";
import { useRecoilState } from "recoil"
import { LoggedUser } from "../../../atoms/userLogged";
import { selectedClientHeader } from "../../../atoms/selectedClientHeader";

export default function FutureReleases() {
  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const user = useRecoilState(LoggedUser)[0];
  const selectedId = useRecoilState(selectedClientHeader)[0];
  const id = user.idLoginTipo === 4 ? Number(jwtToken.idCliente) : Number(selectedId);
  // const id = Number(jwtToken.idCliente);

  const dataInicio = moment(Date())
    .add(1, "day")
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm:ss");
  const dataFim = moment(Date())
    .add(1, "day")
    .endOf("day")
    .format("YYYY-MM-DDTHH:mm:ss");

  const [extractList, setExtractList] = useState(Array<simplifiedExtract>);
  const initialValues = {
    initialDateFilter: dataInicio,
    finalDateFilter: dataFim,
  };

  const [filtros, setFiltros] = useState(initialValues);
  const [loading, setLoading] = useState(false);

  async function getExtractDetails() {
    try {
      setLoading(true);
      const response = await ExtratoApi.getExtractPerClient(
        1,
        100,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        id
      );
      console.log("extrato lancamentos futuros", response)
      setExtractList(response.data);
      setLoading(false);
    } catch (error) {
      console.log("error", error);
    }
  }

  useEffect(() => {
    if (id !== 0) {
      getExtractDetails();
    }
  }, [filtros.initialDateFilter, filtros.finalDateFilter, id]);

  return (
    <Flex
      w={"100%"}
      h={"100%"}
      bgColor={WHITE}
      shadow={"xl"}
      flexDirection={"column"}
      overflowY={"scroll"}
    >
      <Box mb={"10px"} width={"100%"} height={"fit-content"} mx="auto" px={3}>
        <Flex px={8} alignItems="center">
          <FaPlay color={BLUEMONEDDBUTTONS} size="25px" />
          <Text
            mx={4}
            my={4}
            color={BLUEMONEDDBUTTONS}
            fontSize={35}
            fontWeight={"bold"}
          >
            Lançamentos Futuros
          </Text>
        </Flex>
      </Box>
      <Flex
        w={"97%"}
        h={"8%"}
        py={4}
        px={10}
        marginX={"auto"}
        mb={4}
        border={"2px solid #e3e3e3"}
        shadow={"md"}
        borderRadius={"8px"}
        justifyContent={"space-evenly"}
        alignItems={"center"}
      >
        <DateDropdownFuture filtros={filtros} setFiltros={setFiltros} />
      </Flex>
      <Flex
        w={"100%"}
        h={"60vh"}
        alignItems={"flex-start"}
        px={5}
        flexDirection={"column"}
      >
        {extractList?.filter(
          (item: any) =>
            // item.tipoLancamento.lancamento == "Venda Cartão Crédito"
            item.tipoLancamento.id == 1
        ).length ? (
          <TableSalesCredit
            data={
              extractList &&
              extractList.filter(
                (item: any) =>
                  // item.tipoLancamento.lancamento == "Venda Cartão Crédito"
                  item.tipoLancamento.id == 1
              )
            }
            title={"Vendas no cartão de Crédito"}
          />
        ) : (
          <></>
        )}
        {extractList?.filter(
          (item: any) =>
            // item.tipoLancamento.lancamento == "Venda Cartão Crédito"
            item.tipoLancamento.id == 2
        ).length ? (
          <TableSalesCredit
            data={
              extractList &&
              extractList.filter(
                (item: any) =>
                  // item.tipoLancamento.lancamento == "Venda Cartão Crédito"
                  item.tipoLancamento.id == 2
              )
            }
            title={"Cancelamentos de Vendas no Cartão"}
          />
        ) : (
          <></>
        )}
      </Flex>
    </Flex>
  );
}
